import React from 'react'
import usePageContext from '../../../hooks/usePageContext'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import { mapButtonProps } from '../../atoms/Button/utils'
import DepositAndWithdrawSection from '../../sections/DepositAndWithdrawSection'
import { DepositAndWithdrawSliceProps } from './types'

const DepositAndWithdrawSlice: React.FC<DepositAndWithdrawSliceProps> = ({ slice }) => {
  const {
    button_text,
    button_type,
    button_link,
    button_caption,
    button_caption_mobile_size,
    button_caption_desktop_size,
    button_is_centered
  } = slice.primary || {}

  const { group } = usePageContext()

  return (
    <DepositAndWithdrawSection
      inner="inners.primary"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['80px', '', '100px']}
      data={{
        image: {
          publicURL: slice.primary?.image?.url,
          childImageSharp: slice.primary?.image && {
            gatsbyImageData: slice.primary?.image.gatsbyImageData
          },
          width: slice.primary?.image?.dimensions?.width,
          height: slice.primary?.image?.dimensions?.height,
          alt: slice.primary?.image?.alt
        },
        title: slice.primary?.title?.text,
        description: slice.primary?.description?.text,
        button: mapButtonProps(
          button_type,
          button_text,
          resolvePrismicLink(button_link, group),
          button_link?.link_type,
          button_caption,
          button_caption_mobile_size,
          button_caption_desktop_size,
          button_is_centered
        ),
        list: (slice.items || []).map((item, index) => ({
          key: index,
          image: item?.image
        }))
      }}
    />
  )
}

export default DepositAndWithdrawSlice
